module.exports = __webpack_public_path__ + "img/智能管理.624817f1.png";